import { render, staticRenderFns } from "./kfComponent.vue?vue&type=template&id=15952b54&scoped=true"
import script from "./kfComponent.vue?vue&type=script&lang=js"
export * from "./kfComponent.vue?vue&type=script&lang=js"
import style0 from "./kfComponent.vue?vue&type=style&index=0&id=15952b54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15952b54",
  null
  
)

export default component.exports